import { render } from "./EmployeeTopBar.vue?vue&type=template&id=376ed1fe"
import script from "./EmployeeTopBar.vue?vue&type=script&lang=js"
export * from "./EmployeeTopBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__